import { userListToLabelEmailPhoneValue } from '../../../../Apis/functions';
import ButtonIcon from '../../../../components/buttons/ButtonIcon';
import { CleanIcon, DeliveryBoxIcon, DeliveryDocument, FileTracking } from '../../../../components/buttons/IconButtons';
import CustomAddChipSearch from '../../../../components/CustomAddChipSearch';
import CustomCard from '../../../../components/CustomCard';
import CustomDateTimePicker from '../../../../components/CustomDateTimePicker';
import { CustomTextField } from '../../../../components/CustomTextField';
import CustomModal from '../../../../components/Modal/CustomModal';
import CustomPhotoPicker from '../../../../components/PhotoPicker/CustomPhotoPicker';
import { SUGGESTION_MODE_OPTION } from '../../../../components/PhotoPicker/SubComponent/Models/Models';
import { ACTION_MODEL } from '../../../../Helpers/ActionModel';
import { FILE_TYPE } from '../../../../Helpers/fileType';
import DeliveryModalApp from '../Functionality/DeliveryModalApp';
/**
 *
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend Developer - IBL
 * @Email: sgarcia@ibl.mx
 */
const DeliveryModal = (props) => {
    const { onHide, show } = props;

    const {
        t,
        handleConfirm,
        handleClear,
        photoPicker,
        setPhotoPicker,
        emptyFields,
        disabled,
        item,
        handleChange,
        selectedList,
        userTypeToSearch,
        setSelectedList,
        setDisplayModal,
        clear,
        setClear,
    } = DeliveryModalApp({ onHide });
    return (
        <CustomModal
            {...props}
            size='lg'
            display={show}
            buttonConfirm='confirm'
            confirmButton={true}
            cancelButton={true}
            onConfirm={handleConfirm}
            classNameBody='m-0 p-0'
            onHide={onHide}
            topLeftHeader={
                <div className='d-flex align-items-center'>
                    <DeliveryBoxIcon />
                    <p className='fs-24px ibl-font-w-600  font-color-general-950 font-color-primary-600 ml-2'>
                        {t('record_delivery')}
                    </p>
                    <div className='vertical-separator h-auto' />
                </div>
            }
        >
            <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>
                <DeliveryDocument className={'w-100'} />

                <div className='mr-3 ml-3'>
                    <div className='d-flex justify-content-end mt-3 mb-3'>
                        <ButtonIcon
                            id='btn_dm_clean'
                            Icon={CleanIcon}
                            onClick={handleClear}
                            emptyFields={emptyFields}
                            title={'clear_instances'}
                            className={'btn-clean-secondary-600'}
                            tooltipPlacement={'right'}
                            iconProps={'btn-icon-svg-12px icon-color-general-00'}
                        />
                    </div>
                    <CustomDateTimePicker
                        id={'dp_dm_date_time'}
                        name={'dateTime'}
                        disabled={disabled}
                        onChange={(e) => {
                            handleChange({ target: { value: e, name: 'dateTime' } });
                        }}
                        trans={'date_and_time'}
                        value={item?.dateTime}
                        required={true}
                        disablePast={false}
                        openTo={'day'}
                        emptyFields={emptyFields}
                        disableFuture={true}
                    />
                    <CustomAddChipSearch
                        autocompleteId={'slt_dm_employee'}
                        buttonId={'btn_dm_employee'}
                        selectedList={selectedList}
                        setSelectedList={setSelectedList}
                        userTypeIdsSearch={[userTypeToSearch]}
                        label='received_by'
                        emptyFields={emptyFields}
                        required={true}
                        reset={false}
                        keyId={'userId'}
                        showSubSection={true}
                        sanitizeDataList={userListToLabelEmailPhoneValue}
                        completeWidth={true}
                    />
                    <div className='mb-4'>
                        <p className='ibl-font-w-700 text-uppercase text-center mb-3'>{t('provide_reason_delivery')}</p>
                    </div>
                    <CustomTextField
                        id={'txt_dm_name'}
                        length={128}
                        name={'deliveryNote'}
                        value={item?.deliveryNote}
                        emptyFields={emptyFields}
                        trans={'delivery_note'}
                        type={'text'}
                        placeholder={t('add_delivery_details')}
                        onChange={handleChange}
                        required={true}
                        multiline={true}
                    />
                    <div className='mb-4'>
                        <p className='ibl-font-w-700 text-uppercase text-center mb-3'>
                            {t('attach_evidence_required')}
                        </p>
                    </div>
                    <div className='col-12 mb-4'>
                        <CustomPhotoPicker
                            id='fu_dm_file'
                            photoPicker={photoPicker}
                            setPhotoPicker={setPhotoPicker}
                            actionModel={ACTION_MODEL.CREATE}
                            accept={{ ...FILE_TYPE.IMAGE_FILES }}
                            classWith={'w-100'}
                            required={true}
                            emptyFields={emptyFields}
                            validateFace={false}
                            showBtnCamera={true}
                            showPreview={false}
                            typeSuggestions={SUGGESTION_MODE_OPTION.MATERIAL_AND_EQUIPMENT}
                            setDisplayModal={setDisplayModal}
                            clear={clear}
                            setClear={setClear}
                        />
                    </div>
                </div>
            </CustomCard>
        </CustomModal>
    );
};

export default DeliveryModal;
